import { createInstance } from '@/helpers/api/base'
import { Hub } from '@/types/hub'
import { useAppQuery } from '@/helpers/api/query'

const HUBS_KEY = 'HUBS'

export const useGetHubs = (getDefault?: boolean) =>
    useAppQuery<Hub[]>({
        queryKey: [HUBS_KEY, getDefault],
        queryFn: () =>
            createInstance({
                url: '/hubs',
                method: 'GET',
                params: {
                    ...(getDefault && { getDefault }),
                },
            }),
        staleTime: Infinity,
        refetchInterval: 1000 * 60, // Refetch every 60 seconds
        refetchIntervalInBackground: true, // Continue polling even if the tab is inactive
        refetchOnMount: false,
    })
